import { Box, IconNew, Loader, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { memo } from 'react'
import { styles } from './styles'

interface TopActionButtonInterface {
  loading: boolean
  downloadQR: () => void
  downloadingQr: boolean
  isValid: boolean
}

export const TopActionButton = memo(
  ({ loading, downloadQR, downloadingQr, isValid = false }: TopActionButtonInterface) => {
    return (
      <Box {...styles.topShareContainer}>
        {/* TODO: Once Share is available! */}
        {/* <Box {...styles.shareButton}>
        <IconNew id={'SHARE'} color="BLUE" size={14} />
        <SpacerNew size={7} direction="horizontal" />
        <TextNew title={'Share'} {...styles.shareText} />
      </Box> */}
        <Spacer direction="horizontal" size={16} />
        <Box
          onPress={downloadQR}
          disabled={!isValid || loading || downloadingQr}
          {...styles.downloadButton}
          opacity={!isValid || loading ? 0.5 : 1}
          testID={'downloadQrBtn'}>
          {downloadingQr ? (
            <Loader color={'WHITE'} />
          ) : (
            <>
              <IconNew id={'DOWNLOAD'} color="WHITE" size={14} />
              <SpacerNew size={7} direction="horizontal" />
              <TextNew title={'Download QR'} {...styles.downloadText} />
            </>
          )}
        </Box>
      </Box>
    )
  },
)
